import React, { useEffect, useState } from "react";
import { Avatar, Box, Button, Card, CardContent, Container, Divider, Grid, Grid2, Modal, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import Layout from "./Layout";
import GroupIcon from '@mui/icons-material/Group';
import LeadsImg from '../images/Leads.png'
import EligibleLeadsImg from '../images/Eligible.png'
import IneligibleLeadsImg from '../images/Ineligible.png'
import AssignedImg from '../images/Assigned2.png'
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import Link from '@mui/material/Link';
import { DropzoneDialog } from "mui-file-dropzone";
import uploadCompletedImg from '../images/UploadCompleted.png'
import { useDispatch, useSelector } from "react-redux";
import { getAllLeads, uploadLeads } from "../actions/leadsAction";
import { pathOr } from "ramda";
import moment from "moment";
import { formatCurrency } from "../helpers/formatter";
import {  useNavigate } from "react-router";

const Dashboard = () => {
    const { leads } = useSelector(state => state.Leads)
    const navigate = useNavigate()
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        //   border: '2px solid #000',
        boxShadow: 24,
        pt: 4,
        pl: 4, pr: 4
    };
    useEffect(() => {
        dispatch(getAllLeads())
    }, []);
    const [isOpen, setOpen] = useState(false);
    const [stat, setStat] = React.useState(false);
    const handleOpen = () => setStat(true);
    const handleClose = () => setStat(false);
    const [uploadResults, setUPloadResults] = useState({
        eligiblePolicy:0,
        inEligiblePolicy:0,
        totalPolicy:0
    })
    const dispatch = useDispatch();
    const handleUpload = async (files) => {
        console.log(files[0])
        var reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = async function () {
            console.log(reader.result.split("base64,")[1]);
            const response = await dispatch(uploadLeads({ file: reader.result.split("base64,")[1] }))
            setUPloadResults({
                eligiblePolicy:response.eligiblePolicy,
                inEligiblePolicy:response.inEligiblePolicy,
                totalPolicy:response.totalPolicy
            })
            setOpen(false);
            handleOpen(true)
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    const latestSms = leads.filter(a => a.smsSent ).sort(function (a, b) {
            return new Date(b.smsSentDate) - new Date(a.smsSentDate);
    }).slice(0,5);

    const latestEsign = leads.filter((a) => {
        return pathOr(false, ["assignments", "0", "isSigned"], a) !== false;
    })

    const rows = [
        { id: 1, policyNumber: '242525235', firstName: 'Rohith Sharma', surrenderValue: '₹ 7,49,876', createdOn: '20/11/2024 10:57:46' },
        { id: 2, policyNumber: '242525235', firstName: 'Rohith Sharma', surrenderValue: '₹ 7,49,876', createdOn: '20/11/2024 10:57:46' },
        { id: 3, policyNumber: '242525235', firstName: 'Rohith Sharma', surrenderValue: '₹ 7,49,876', createdOn: '20/11/2024 10:57:46' },
        { id: 4, policyNumber: '242525235', firstName: 'Rohith Sharma', surrenderValue: '₹ 7,49,876', createdOn: '20/11/2024 10:57:46' },
        { id: 5, policyNumber: '242525235', firstName: 'Rohith Sharma', surrenderValue: '₹ 7,49,876', createdOn: '20/11/2024 10:57:46' },
    ];

    return (
        <>
            <Layout>
                <React.Fragment>
                    <Container>
                        <Typography variant="h4" mt={2} mb={2}>{"Dashboard"}</Typography>
                        <Grid2 container spacing={3}>
                            <Grid2 lg={3} sm={6} xs={12}>
                                <Card >
                                    <CardContent>
                                        <Stack spacing={3}>
                                            <Stack direction="row" sx={{ alignItems: 'flex-start', justifyContent: 'space-between' }} spacing={3}>
                                                <Stack spacing={1}>
                                                    <Typography color="text.secondary" variant="overline">
                                                        Total Leads
                                                    </Typography>
                                                    <Typography variant="h4">{leads.length}</Typography>
                                                </Stack>
                                                <Avatar variant="rounded"
                                                    alt="Leads"
                                                    sx={{ backgroundColor: '#80FF8F', width: 42, height: 42 }}
                                                >
                                                    <img style={{ height: 24, width: 32 }} className="" src={LeadsImg} alt="logo" />
                                                </Avatar>
                                            </Stack>
                                        </Stack>
                                    </CardContent>
                                </Card>
                            </Grid2>
                            <Grid2 lg={3} sm={6} xs={12}>
                                <Card >
                                    <CardContent>
                                        <Stack spacing={3}>
                                            <Stack direction="row" sx={{ alignItems: 'flex-start', justifyContent: 'space-between' }} spacing={3}>
                                                <Stack spacing={1}>
                                                    <Typography color="text.secondary" variant="overline">
                                                        Total Eligible
                                                    </Typography>
                                                    <Typography variant="h4">{leads.filter(l => l.isAssignmentEligible).length}</Typography>
                                                </Stack>
                                                <Avatar variant="rounded"
                                                    alt="Eligible Leads"
                                                    sx={{ backgroundColor: '#FFF3D6', width: 42, height: 42 }}
                                                >
                                                    <img style={{ height: 32, width: 32 }} className="" src={EligibleLeadsImg} alt="logo" />
                                                </Avatar>
                                            </Stack>
                                        </Stack>
                                    </CardContent>
                                </Card>
                            </Grid2>
                            <Grid2 lg={3} sm={6} xs={12}>
                                <Card >
                                    <CardContent>
                                        <Stack spacing={3}>
                                            <Stack direction="row" sx={{ alignItems: 'flex-start', justifyContent: 'space-between' }} spacing={3}>
                                                <Stack spacing={1}>
                                                    <Typography color="text.secondary" variant="overline" >
                                                        Total Ineligible Leads
                                                    </Typography>
                                                    <Typography variant="h4">{leads.filter(l => !l.isAssignmentEligible).length}</Typography>
                                                </Stack>
                                                <Avatar variant="rounded"
                                                    alt="Eligible Leads"
                                                    sx={{ backgroundColor: '#FFDED1', width: 42, height: 42 }}
                                                >
                                                    <img style={{ height: 32, width: 32 }} className="" src={IneligibleLeadsImg} alt="logo" />
                                                </Avatar>
                                            </Stack>
                                        </Stack>
                                    </CardContent>
                                </Card>
                            </Grid2>
                            <Grid2 lg={3} sm={6} xs={12}>
                                <Card >
                                    <CardContent>
                                        <Stack spacing={3}>
                                            <Stack direction="row" sx={{ alignItems: 'flex-start', justifyContent: 'space-between' }} spacing={3}>
                                                <Stack spacing={1}>
                                                    <Typography color="text.secondary" variant="overline">
                                                        Total Assigned Policies
                                                    </Typography>
                                                    <Typography variant="h4">{leads.filter(l => l.journeyStatus==='assigned').length}</Typography>
                                                </Stack>
                                                <Avatar variant="rounded"
                                                    alt="Assigned Leads"
                                                    sx={{ backgroundColor: '#D9F7E8', width: 42, height: 42 }}
                                                >
                                                    <img style={{ height: 32, width: 32 }} className="" src={AssignedImg} alt="logo" />
                                                </Avatar>
                                            </Stack>
                                        </Stack>
                                    </CardContent>
                                </Card>
                            </Grid2>
                        </Grid2>
                        <Grid2 container mt={3} mb={1}>
                            <Grid2 size={4}>
                                <Typography variant="h5">{"Policy Assignment Leads"}</Typography>
                            </Grid2>
                            <Grid2 size={2}>
                                <Button variant="contained" sx={{ background: '#4DA235' }} onClick={() => { setOpen(true) }}>Add Bulk Leads</Button>
                            </Grid2>
                            <Grid2 size={2}>
                                <Button variant="outlined" color="#4DA235" sx={{ color: '#4DA235' }} onClick={()=>{navigate('/addleads')}}>Add Lead</Button>
                            </Grid2>
                        </Grid2>
                        <Typography variant="caption">{"Click the 'Add Bulk Leads' button to import leads in bulk or use the 'Add Lead' option for manual entry."}</Typography>
                        <Grid2 spacing={2} container mt={2}>
                            <Grid2 item size={6}>
                                <Paper style={{ background: '#fff' }}>
                                    <div className="rowClass">
                                        <Typography sx={{ fontWeight: 600 }} p={2}>{"Latest SMS sent"}</Typography>
                                        <Link mr={2} href="/leads">View All</Link>
                                    </div>
                                    <TableContainer component={Paper}>
                                        <Table sx={{ minWidth: 550 }} aria-label="simple table">
                                            <TableHead sx={{ background: '#E8F9DF' }}>
                                                <TableRow>
                                                    <TableCell>Policy Number</TableCell>
                                                    <TableCell>Customer Name</TableCell>
                                                    <TableCell align="right">Surrender Value</TableCell>
                                                    <TableCell align="center">Date</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {latestSms.map((row) => (
                                                    <TableRow
                                                        key={row._id}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell component="th" scope="row">
                                                            {row.policyNumber}
                                                        </TableCell>
                                                        <TableCell align="left">{row.policyHolderName}</TableCell>
                                                        <TableCell align="right">{`₹ ${formatCurrency(row.surrenderValue)}`}</TableCell>
                                                        <TableCell align="center">{moment(row.createdAt).format('DD-MM-YYYY')}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Paper>
                            </Grid2>
                            <Grid2 item size={6}>
                                <Paper style={{ background: '#fff' }}>
                                    <div className="rowClass">
                                        <Typography sx={{ fontWeight: 600 }} p={2}>{"Latest E-sign completed policies"}</Typography>
                                        <Link mr={2} href="/leads">View All</Link>
                                    </div>
                                    <TableContainer component={Paper}>
                                        <Table sx={{ minWidth: 550 }} aria-label="simple table">
                                            <TableHead sx={{ background: '#E8F9DF' }}>
                                                <TableRow>
                                                    <TableCell>Policy Number</TableCell>
                                                    <TableCell>Customer Name</TableCell>
                                                    <TableCell align="right">Surrender Value</TableCell>
                                                    <TableCell align="center">Date</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {leads.map((row) => {
                                                    const isSigned = pathOr(false, ["assignments", "0", "isSigned"], row)
                                                    console.log(isSigned)
                                                    if (isSigned) {
                                                        return (
                                                            <TableRow
                                                                key={row.name}
                                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                            >
                                                                <TableCell component="th" scope="row">
                                                                    {row.policyNumber}
                                                                </TableCell>
                                                                <TableCell align="left">{row.policyHolderName}</TableCell>
                                                                <TableCell align="right">{`₹ ${formatCurrency(row.surrenderValue)}`}</TableCell>
                                                                <TableCell align="center">{moment(row.createdAt).format("DD-MM-YYYY")}</TableCell>
                                                            </TableRow>
                                                        )
                                                    }
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Paper>
                            </Grid2>
                        </Grid2>
                        <DropzoneDialog
                            style={{ background: 'red' }}
                            open={isOpen}
                            onSave={(files) => { handleUpload(files) }}
                            acceptedFiles={["application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"]}
                            showPreviews={true}
                            maxFileSize={5000000}
                            onClose={() => { setOpen(false) }}
                        />
                        <Modal
                            open={stat}
                            onClose={handleClose}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                        >
                            <Box sx={style} justifyItems={'center'} >
                                <img style={{ height: 168, width: 168 }} src={uploadCompletedImg}></img>
                                <Typography id="modal-modal-title" variant="h6" mt={4} component="h2">
                                    Upload Complete
                                </Typography>
                                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                    your file have been uploaded successfully
                                </Typography>
                                <Grid2 container spacing={4} mt={2} mb={2}>
                                    <Grid2 item>
                                        <Typography variant="body2" color="#4DA235">{`${uploadResults.eligiblePolicy} - Eligible Leads`}</Typography>
                                    </Grid2>
                                    <Grid2 item>
                                        <Typography variant="body2" color="#C64545">{`${uploadResults.inEligiblePolicy} - Ineligible Leads`}</Typography>
                                    </Grid2>
                                </Grid2>
                                <Divider></Divider>
                                <Box p={4} sx={{ background: "#4DA235", width: '100%', textAlign: 'center' }}>
                                    <Button sx={{ color: '#4DA235', background: '#fff' }} onClick={handleClose} variant="contained">Continue</Button>
                                </Box>
                            </Box>
                        </Modal>
                    </Container>
                </React.Fragment>
            </Layout>
        </>
    )
}

export default Dashboard